import { render, staticRenderFns } from "./Snot22Block.vue?vue&type=template&id=a26e5e1a&lang=pug&"
import script from "./Snot22Block.vue?vue&type=script&lang=js&"
export * from "./Snot22Block.vue?vue&type=script&lang=js&"
import style0 from "./Snot22Block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports